export class RepositoryCreationError extends Error {}
